import cf from './cf';
import i1zv1 from './i1zv1_20211024';

export default class i1zv1c extends i1zv1 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    global.t = this;
    this.d_viewDefs = {
      name: '優先エントリー',
      class: 'i1zv1c',
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
